import React, { useState } from 'react';
import VectorizationEditor from '@/components/tools/image-to-vector/VectorizationEditor';
import { FileUploader } from "@/components/ui/FileUploader";
import { Icon } from "@iconify/react";
import { usePathname } from "next/navigation";
import { getLocaleFromPathname } from "@/lib/i18n";
import { getVectorToolCopy } from "@/lib/vector-tool-copy";
import { tools } from "@/config/tools";
import { getLocalizedTool } from "@/lib/tool-localization";

export default function ImageToVectorTool() {
  const [file, setFile] = useState<File | null>(null);
  const pathname = usePathname() || "/";
  const locale = getLocaleFromPathname(pathname);
  const copy = getVectorToolCopy(locale);
  const localizedTool = getLocalizedTool(
    tools.find((item) => item.id === "image-to-vector") ?? tools[0],
    locale
  );

  if (file) {
      return <VectorizationEditor file={file} onBack={() => setFile(null)} />;
  }

  return (
    <div className="space-y-8">
      <div className="rounded-[20px] border border-positivus-dark/10 bg-positivus-green/10 p-6 mb-8">
        <div className="flex items-start gap-4">
          <div className="hidden md:block rounded-full bg-positivus-green/20 p-2">
            <Icon icon="mdi:vector-curve" className="h-6 w-6 text-positivus-dark" />
          </div>
          <div className="text-sm text-positivus-dark w-full">
            <p className="font-medium text-lg mb-2">{localizedTool.name || copy.title}</p>
            <p className="leading-relaxed">
              {copy.description}{" "}
              <strong>{copy.accurate}</strong>
            </p>
          </div>
        </div>
      </div>

      <FileUploader
        accept="image/*"
        onFilesSelected={(files) => {
             if (files?.[0]) setFile(files[0]);
        }}
        className="min-h-[400px]"
      />
    </div>
  );
}
